import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../utils";
import PageSubheader from "../../../../components/PageSubheader";
import AttributeKeyForm from "../form";

interface Props {
  intl: IntlShape;
  backURL: string;
}

const CreateAttributeKey = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.attr.key.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-attr-key-create"
        goBackURL={backURL}
      />

      <AttributeKeyForm {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreateAttributeKey));
